/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const StoreLegalDocumentType = {
    TOS: 'tos',
    Imprint: 'imprint',
    WithdrawalRights: 'withdrawal'
};
